import { getGtmData } from '..';
const transaction = () => ({
  pastTransactionPageLoad: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: 'vpv/pfm/online-investments/transactions/past-transactions/home',
    //   title: 'PFM - Online Investments - Transactions - Past Transactions - Home',
    //   cd24: getGtmData('cd24') //<<pass platform either website or internet-banking or mobile-app>>
    // }),
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Transactions - Past Transactions - Landing Screen'
    // })
  },

  // actionType can be My Holdings, Statements, or Back
  // transactionType could be either Past Transactions or Systematic Transaction
  transactionPageOnClickAction: (transactionType: string, actionType: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Transactions - ${transactionType} - Landing Screen - ${actionType}`
    // })
  },

  systematicTransactionClick: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Transactions - Landing Screen - Systematic Transactions'
    // })
  },

  pastTransactionClick: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Transactions - Landing Screen - Past Transactions'
    // })
  },

  // 2. Systematic Transaction Page
  systematicTransactionPageLoad: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: 'vpv/pfm/online-investments/transactions/systematic-transactions/home',
    //   title: 'PFM - Online Investments - Transactions - Systematic Transactions - Home'
    // }),
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Transactions - Systematic Transactions - Landing Screen'
    // })
  },

  onSystematicTransactionStopClick: (scheme: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Transactions - Landing Screen - ${scheme} - Stop`
    // })
  },

  // 3. Systematic Transaction cancel page
  // transaction type can be SIP, STP, SWP, SWITCH, etc.
  transactionCancelPageLoad: (scheme: string, transactionType: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: `vpv/pfm/online-investments/transactions/systematic-transactions/${scheme}/stop/${transactionType.toLowerCase()}-cancellation`,
    //   title: `PFM - Online Investments - Transactions - Systematic Transactions - ${scheme} - Stop - ${transactionType} Cancellation`
    // }),
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Transactions - Systematic Transactions - ${scheme} - Stop - ${transactionType} Cancellation`
    // })
  },

  // actionType can be Back, Terms And Conditions or Proceed
  transactionCancelOnClickAction: (scheme: string,  transactionType: string, actionType: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Transactions - Systematic Transactions - ${scheme} - Stop - ${transactionType} Cancellation - ${actionType}`
    // })
  },

  verifyOtpModalOnLoad: (scheme: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: `vpv/pfm/online-investments/transactions/systematic-transactions/${scheme}/stop/sip-cancellation/verify-otp`, // TODO: pass scheme inside a util that removes ' ' and replaces with -
    //   title: `PFM - Online Investments - Transactions - Systematic Transactions - ${scheme} - Stop - SIP Cancellation - Verify OTP`
    // }),
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Transactions - Systematic Transactions - ${scheme} - Stop - SIP Cancellation - Verify OTP`
    // })
  },

  // 4. OTP Modal
  // actionType here could be either Close or Submit
  verifyOtpModalOnClickAction: (scheme: string, actionType: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Transactions - Systematic Transactions - ${scheme} - Stop - SIP Cancellation - Verify OTP - ${actionType}`
    // })
  },

  // 5. Transaction success page
  successPageLoad: (scheme: string, transactionType: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: `vpv/pfm/online-investments/transactions/systematic-transactions/${scheme}/stop/sip-cancellation-request-submitted`,  // TODO: pass scheme inside a util that removes ' ' and replaces with -
    //   title: `PFM - Online Investments - Transactions - Systematic Transactions - ${scheme} - Stop - SIP Cancellation Request Cancellation Request Submitted`
    // }),
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Transactions - Systematic Transactions - ${scheme} - Stop - ${transactionType} Cancellation Request Submitted`
    // })
  },

  successPageGoBackTextClick: (scheme: string, goBackMessage: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Transactions - Systematic Transactions - ${scheme} - Stop - SIP Cancellation Request Submitted - ${goBackMessage}`
    // })
  },
  // actionButton will be the text of the buttons, can be "Every Goal Deserves a SIP. Start one more SIP" pr "Start a SIP in International Funds"
  successPageActionButtonsClick: (scheme: string, transactionType: string, actionButton: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Transactions - Systematic Transactions - ${scheme} - Stop - ${transactionType} Cancellation Request Submitted - ${actionButton}`
    // })
  }
})

export default transaction;